export default "__VITE_ASSET__BeeLN$pL__"